export type ProxyDelegateCall = {
  implementationAddress: string;
  signedDescriptor: string;
  keyId: string;
  keyUsage: string;
};
